import { produce } from "immer";
import { TablesState } from "../interfaces/tables-state";
import _ from "lodash";
import { _isNumberValue } from "@angular/cdk/coercion";


export const setSelectedIndexHandler = function (state: TablesState, tableId: string, index: number | null) {
  // Overlays opened away from their table page (e.g. from the dashboard) can dispatch for a
  // table whose slice was never initialized - nothing to select there.
  if (state[tableId] == undefined) return state;

  const nextState = produce(state[tableId], draft => {
    draft.index = index;
  })

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}

export const setSelectNextIndexHandler = function (state: TablesState, tableId: string) {

  const nextState = produce(state[tableId], draft => {
    if (_.isNumber(draft?.index) ) {
      if (draft.pagination.filteredRecordCount != undefined && draft.index >= draft.pagination.filteredRecordCount - 1) {
        return;
      }
      if (draft.index === -1) {
        draft.index = 0;
      } else {
        draft.index = draft.index + 1;
      }

    }
  })

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}

export const setSelectPreviousIndexHandler = function (state: TablesState, tableId: string) {
  const nextState = produce(state[tableId], draft => {

    if (draft == undefined) return draft;

    if (_.isNumber(draft.index) && draft.index > 0)
      draft.index = draft.index - 1;
  })

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}

export const toggleAllSelectedState = function (state: TablesState, tableId: string) {

  const nextState = produce(state[tableId], draft => {

    if (draft == undefined)
      return draft;

    if (draft.selection) {
      draft.selection.isAllSelected = !draft.selection.isAllSelected;

      // Toggling the header checkbox is a "pristine" select-all (re-applies after filtering).
      draft.selection.selectAllPristine = draft.selection.isAllSelected;

      if (draft.selection.isAllSelected) {
        draft.selection.multipleItemsSelected = false;
      }
    }

  }
  )

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}

export const setMultipleItemsSelectedState = function (state: TablesState, tableId: string, isMultipleItemsSelected: boolean) {

  const nextState = produce(state[tableId], draft => {

    if (draft == undefined)
      return draft;

    if (draft.selection)
      draft.selection.multipleItemsSelected = isMultipleItemsSelected;
  }
  )

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}

export const setAllSelectedState = function (state: TablesState, tableId: string, isAllItemsSelected: boolean) {

  const nextState = produce(state[tableId], draft => {

    if (draft == undefined)
      return draft;

    if (draft.selection) {
      draft.selection.isAllSelected = isAllItemsSelected;

      if (draft.selection.isAllSelected) {
        draft.selection.multipleItemsSelected = false;
      } else {
        // No longer fully selected → not a pristine select-all.
        draft.selection.selectAllPristine = false;
      }
    }
  }
  )

  return {
    ...state,
    [tableId]: { ...nextState }  // Updating the pages property with the new state for the specified area
  };
}

export const setSelectAllPristine = function (state: TablesState, tableId: string, pristine: boolean) {

  const nextState = produce(state[tableId], draft => {

    if (draft == undefined)
      return draft;

    if (draft.selection)
      draft.selection.selectAllPristine = pristine;
  }
  )

  return {
    ...state,
    [tableId]: { ...nextState }
  };
}